import { render, staticRenderFns } from "./districtDistribution.vue?vue&type=template&id=6be1e775&scoped=true"
import script from "./districtDistribution.vue?vue&type=script&lang=js"
export * from "./districtDistribution.vue?vue&type=script&lang=js"
import style0 from "./districtDistribution.vue?vue&type=style&index=0&id=6be1e775&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be1e775",
  null
  
)

export default component.exports